import { bindings } from '@polleverywhere/slideware-bindings'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => { // top-level app state has been reset
    dispatcher.listenTo(state.appStates.slideware, 'change:page', async (slidewareAppState, newPage, options = {}) => {
      const { page } = store.getState()[appSlice.name]
      if (newPage === 'close' && page === 'slideware') {
        await bindings.closeWindow()
      }
    })
  })
}
